export const PlantillaTurnoFormModel = {
  formId: 'plantillaTurnoForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre de la plantilla',
      requiredErrorMsg: 'El nombre es requerido',
    },
    position: {
      name: 'position',
      label: 'Posición',
      requiredErrorMsg: 'La posición es requerida',
    },
    startTime: {
      name: 'startTime',
      label: 'Hora de Inicio',
      requiredErrorMsg: 'La hora de inicio es requerida',
    },
    endTime: {
      name: 'endTime',
      label: 'Hora de Fin',
      requiredErrorMsg: 'La hora de fin es requerida',
    },
    durationHours: {
      name: 'durationHours',
      label: 'Duración (Horas)',
      requiredErrorMsg: 'La duración es requerida',
    },
  },
};
